<template lang="pug">
  .weekday-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        card-back(
          v-if="state === states.start"
          )
          span.question {{ date }}
        card-back.quiz-answer(
          v-else
          )
          button.no(@click="updateState(states.done, { moon: 0, confidence: 0, weekday: 0 })") No!
          button(@click="updateState(states.done, { moon: 1, confidence: 1, weekday: 0 })") Moon
          button(@click="updateState(states.done, { moon: 0, confidence: 1, weekday: 1 })") Weekday
          button.yes(@click="updateState(states.done, { moon: 1, confidence: 2, weekday: 1 })") Both!
      template(v-slot:back)
        card-back
          .answer
            .date {{ date }}
            .moon(:style="{'background-image': `url(/img/moon/${moonPhase}.jpg)`}")
              | {{ moonPhase }}
            .day
              | {{ weekdays[quiz.data.weekday] }}
              sup.number {{quiz.data.weekday}}

</template>

<script>
import { getMoonPhase } from '@/helpers'
import FlipCard from './FlipCard'
import CardBack from './CardBack'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showWeekday: 1,
  answer: 2,
  done: 3,
  finished: 4
};

export default {
  components: {
    FlipCard,
    CardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      weekdays: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      states,
      state: states.start
    };
  },
  computed: {
    date() {
      return `${this.quiz.data.date}.${this.quiz.data.month}.${this.quiz.data.year}`;
    },
    moonPhase() {
      const { year } = this.quiz.data;
      const [month, day] = [this.quiz.data.month, this.quiz.data.date].map(n => n.toString().padStart(2, '0'));
      return getMoonPhase(new Date(`${year}-${month}-${day}`));
    }
  },
  methods: {
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showWeekday);
      }
      if (!flipped && this.state === this.states.showWeekday) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .question, .answer > .day
    font-size 24px

  sup
    font-size .5em
    &:before
      content " "

  .answer, .moon
    display flex
    align-items center
    flex-direction column

  .moon
    height 3.125em
    width 3.125em
    justify-content center
    margin .75em 0
    font-weight 600
    background-size contain
    mix-blend-mode screen
    color #eee
    text-shadow #000 0 0 2px

  .quiz-answer
    padding-top 50%
    display flex
    justify-content space-around
    flex-direction column
    button
      width 75%
      padding 8px
      font-size 12px
      &.no
        background-color rgba(111, 38, 13, .5)
      &.yes
        background-color rgba(38, 84, 16, .5)
</style>
